import { ReactElement, SVGProps } from 'react';
import BaseIcon from "./BaseIcon";

export default function PieChart(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path d="M89.2275 58.8888H54.332L77.5716 83.5813C78.4598 84.525 79.9216 84.6016 80.8348 83.6875C86.526 77.9906 90.4407 70.3108 91.5892 61.6779C91.7863 60.1998 90.6319 58.8888 89.2275 58.8888ZM86.8995 48.7637C85.6878 30.0979 71.6496 15.1821 54.082 13.8946C52.7408 13.7961 51.6114 14.9977 51.6114 16.4258V51.3887H84.5186C85.8628 51.3887 86.9922 50.1887 86.8995 48.7637ZM44.5526 58.8888V21.8118C44.5526 20.3196 43.3188 19.0931 41.9291 19.3024C24.4041 21.9337 11.0086 38.2011 11.6321 57.6966C12.2733 77.7187 28.4982 94.1376 47.3511 93.8861C54.7629 93.7876 61.6114 91.2501 67.2422 87.0063C68.404 86.1313 68.4805 84.3141 67.4731 83.2438L44.5526 58.8888Z" fill="#D2F9FF"/>
    </BaseIcon>
  )
}
